export var variants = {red:'$_204qy',white:'$_2vc--'};
export var attachDirections = {left:'z6bX8',right:'_3eL0d'};